import { isValidQuery } from "components/hostedScrapingValidators";
import { SDEContent } from "./sdecontentTypes";

export const WalmartSearchContent: SDEContent = {
  projectType: 'async_walmart_search',
  projectCategory: 'walmart',
  apiUrlFn: (apiHost: string) => {
    return `${apiHost}/structured/walmart/search/v1`;
  },
  docsSection: 'walmart-search-api',
  docsSectionTitle: 'Walmart Search API',
  docsSectionAsync: 'walmart-search-api-async',
  docsSectionAsyncTitle: 'Walmart Search API (Async)',
  inputKey: 'query',
  inputsKey: 'queries',
  validatorFunction: isValidQuery,
  newProjectEditProject: {
    inputBoxLabels: {
      listLiteralInputTitle: 'Search terms',
      listLiteralInputPlaceholder: 'Enter one search term per line.',
    },
    inputSectionLabels: {
      inputSectionTitle: "Input search term",
      inputSectionDescription: "Enter search terms in the input field or upload CSV with your search terms to begin scraping Walmart.",
    },
    projectContent: {
      title: 'Walmart search',
      description: 'Extract well-structured product data from a keyword search in Walmart like name, price, reviews and URLs.',
      icon: 'walmart',
      inputTitle: 'Query',
    },
  },
  apiPlayground: {
    inputSectionLabels: {
      inputSectionTitle: 'Input search term',
      inputSectionDescription: 'Enter Walmart search terms or full URLs to begin scraping Walmart.',
    },
    projectContent: {
      title: 'Walmart search',
      description: 'Extract well-structured product data from a keyword search in Walmart like name, price, reviews and URLs.',
      icon: 'walmart',
    },
    enterInputsPlaceholder: 'garden hose',
    enterInputsMessage: 'Enter keyword for scraping',
    codeViewPlaceHolder: 'Please provide a valid search term',
    dropdownTitle: 'Walmart Search'
  }
};
